/**
 * @file 单纯staking时的确认内容
 */
import { DirectiondownIcon } from '@bfe/moly-icons';
import { useFm } from '@web3/base-hooks';
import { CoinInfo } from '@/types/common';
import { BigNumber } from 'bignumber.js';
import { usePoolInfoContext } from '@/hooks/usePoolInfo';
import { useAccountInfoContext } from '@/hooks/useAccountInfo';
import { formatUSDYield } from '@/utils/num';

import styles from './index.module.scss';

interface Props {
  currentStakeToken: CoinInfo;
  stakeAmount: string;
  stakeLpInfo: Partial<CoinInfo>;
}

export const StakingContent = (props: Props) => {
  const { currentStakeToken, stakeAmount, stakeLpInfo } = props;
  const { poolInfo } = usePoolInfoContext();
  const { accountInfo } = useAccountInfoContext();
  const { lpCoinDetail } = accountInfo;
  const fm = useFm();

  return (
    <>
      <div className={styles.container}>
        <div className={styles.stakingTitleArea}>
          <div className={styles.stakingTitleLabel}>{fm('invest')}</div>
          <div className={styles.stakingTitleValue}>
            <img src={poolInfo.icon.night} className={styles.stakingIcon} />
            <div className={styles.stakingIconPoolType}>
              {poolInfo.poolType}
            </div>
            <div className={styles.stakingIconPoolTypeText}>
              {fm('contract')}
            </div>
          </div>
        </div>
        <div className={styles.currentToken}>
          <div className={styles.currentTokenLeft}>
            <img
              src={currentStakeToken.iconNightUrl}
              className={styles.currentTokenIcon}
            />
            <div className={styles.currentTokenSymbol}>
              {currentStakeToken?.symbol}
            </div>
          </div>
          <div>
            <div className={styles.currentTokenAmount}>{stakeAmount}</div>
            <div className={styles.currentTokenValue}>
              {currentStakeToken?.price
                ? formatUSDYield(
                    BigNumber(stakeAmount)
                      .times(currentStakeToken.price)
                      .toString()
                  )
                : ''}
            </div>
          </div>
        </div>
        <DirectiondownIcon className={styles.arrowDown} />
        <div>
          <div className={styles.stakingTitleArea}>
            <div className={styles.stakingTitleLabel}>
              {fm('estimate_gain')}
            </div>
          </div>
          <div className={styles.currentToken}>
            <div className={styles.currentTokenLeft}>
              <img
                src={lpCoinDetail?.iconNightUrl}
                className={styles.currentTokenIcon}
              />
              <div className={styles.currentTokenSymbol}>
                {lpCoinDetail?.symbol}
              </div>
            </div>
            <div>
              <div className={styles.currentTokenAmount}>
                {stakeLpInfo.amount ? stakeLpInfo.amount : '--'}
              </div>
              <div className={styles.currentTokenValue}>
                {stakeLpInfo.price
                  ? formatUSDYield(
                      BigNumber(stakeLpInfo.amount || 0)
                        .times(stakeLpInfo.price)
                        .toString()
                    )
                  : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
